
import { useRealtimeSync } from './hooks/useRealtimeSync';

export const AutoSync = () => {
  // Use the realtime sync hook to set up Supabase realtime subscriptions
  useRealtimeSync();
  
  return null;
};
